<template>
    <div class="banner">
        <swiper :options="swiperOptiona" ref="mySwipers" class="swiper"  v-if="bList.length>0">
            <swiper-slide class="item" v-for="(item,index) in bList" :key="index">
                <img :src="`https://www.cabling-vivanco.com/upload/${item.PICURL}`" alt="" @click="goto(index)">
                <div class="text">
                    <!-- <p>
                        {{item.TEXT0}}
                        <span>{{item.TEXT1}}</span>
                    </p> -->
                    <!-- <p class="pm">{{item.TEXT2}}</p> -->
                    <!-- <p class="pm">{{item.TEXT3}}</p> -->
                    <!-- <p class="p3" @click="goto(item.HREF)">Learn more about Vivanco>></p> -->
                    <img src="../assets/yz/xt.png" alt="">
                </div>
                <div class="more">
                         <p>NEXT</p>
                         <span></span>
                </div>
                <div class="line">

                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-pagination">

        </div>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import { getPicUrl} from '../util/lang'
    export default {
        name: "banner",
        data(){
            return{
                bList:[],
                swiperOptiona:{
                    pagination: {
                        el: ".banner .swiper-pagination",
                        clickable: true,
                        renderBullet: function(index, className) {
                            return '<span class="' + className + '"><i></i></span>';
                        }
                    },
                    loop: true,
                    effect: 'fade',
                    init: true,
                    speed:5000,
                    autoplay:{
                        disableOnInteraction: false,
                        delay: 5000
                    }
                    // autoplay:false
                },
            }
        },
        components: {
            swiper,
            swiperSlide,
        },
        mounted(){
            this.$nextTick(()=>{
                if(document.body.clientWidth<1000){
                    this.getList2()
                }else{
                    this.getList()
                }
            })
        },
        methods:{
            goto(n){
                let link
                if(n==0){
                    link='./about.html'
                }else if(n==1) {
                    link='./health.html'
                }
               window.open(link,'_self')
            },
            aStyle(n){
                return {animationDelay:n*0.5+0.5+'s'}
            },
            getList(){
                const url = `${getPicUrl( 'zh-CN','首页banner',8)}`
                this.$axios.get(url).then(res => {
                    this.bList=res.data
                    setTimeout(()=>{
                        this.$refs.mySwipers.swiper.init()
                    },100)
                })
            },
            getList2(){
                const url = `${getPicUrl( 'zh-CN','首页手机端banner',10)}`
                this.$axios.get(url).then(res => {
                    this.bList=res.data
                    setTimeout(()=>{
                        this.$refs.mySwipers.swiper.init()
                    },100)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.banner{
    width:100%;
    /*height:720px;*/
    position: relative;
    .swiper{
        height:100%;
        .item{
            position: relative;
            overflow: hidden;
            img{
                width:100%;
                height:100%;
                object-fit: cover;
                display: block;
                z-index: 1;
                cursor: pointer;
                transform: scale3d(1.2, 1.2, 1.2);
                transition: all 5s cubic-bezier(0.04, 0.79, 1, 1);
            }
            .text{
                z-index: 10;
                position: absolute;
                left: 14%;
                top:37%;
                color:white;
                text-transform: uppercase;
                p:nth-child(1){
                    color:white;
                    font-size: 45px;
                    font-family: os;
                    position: relative;
                    border-bottom: 1px solid rgba(255,255,255,.2);
                    padding-bottom: 20px;
                    span{
                        color:#91C131;
                    }
                }
                p:nth-child(1)::after{
                       position: absolute;
                       left:0;
                       width:0;
                    height:1px;
                    background-color: #F7BC30;
                    display: inline-block;
                    content:'';
                    bottom:0px;
                    transition: all 1s;
                   }
                .pm{
                    color:#cccccc;
                    width:100%;
                  font-family: "Fira Code Medium";
                    font-weight: lighter;
                    padding-top: 20px;
                    line-height: 30px;
                    text-transform: none;
                }
                .p3{
                    color:#cccccc;
                    font-family: "Fira Code Medium";
                    font-weight: lighter;
                    text-transform: none;
                    padding: 30px 0;
                    cursor: pointer;
                }
                img{
                    width:141px;
                    height:12px;
                }
            }
            .more{
                left: 14%;
                bottom:10%;
                width:45%;
                position: absolute;
                display: flex;
                flex-direction: row;
                align-items: center;
                p{
                    font-family: "Fira Code Medium";
                    font-weight: lighter;
                    color:#cccccc;
                }
                span{
                    display: inline-block;
                    width:50%;
                    background-color: rgba(255,255,255,.2);
                    height:1px;
                    margin-left: 1%;
                }
            }
            .line{
                position: absolute;
                top:0;
                right:12.5%;
                height:100vh;
                width:1px;
                background-color: rgba(255,255,255,.1);
            }
        }
        .swiper-slide-active{
            .text{
                p{
                    // text-shadow: 2px 2px 6px rgba(0,0,0,.8);
                }
              p:nth-child(1){
                  width:100%;
                  white-space:nowrap;
                  overflow:hidden;
                  animation: type 5s steps(50, end) forwards;
              }
                p:nth-child(1)::after{
                    width:45%;
                }
                .pm{
                    white-space:nowrap;
                    overflow:hidden;
                    animation: type 5s steps(50, end) forwards;
                }
                @-webkit-keyframes type{
                    from { width: 0;}
                }

                @keyframes type{
                    from { width: 0;}
                }
            }
            img{
                transform: scale3d(1, 1, 1);
                transition: all 5s cubic-bezier(0.04, 0.79, 1, 1);

            }
        }
    }
    @media screen and (min-width:2500px){
  .swiper{
      .item{
          .text{
              p:nth-child(2){
                  width:60%;
              }
          }
      }
  }
    }
    @media screen and (max-width: 1440px){
        // .swiper{
        //     .item{
        //         .text{
        //             left:5%;
        //         }
        //         .line{
        //             right:15%;
        //         }
        //     }
        // }
    }
    @media screen and (max-width:450px){
        .swiper{
            .item{
                .text{
                    left:2.5%;
                    width:95%;
                    p:nth-child(1){
                        font-size: 30px;
                        width:100%;
                    }
                    .pm{
                        font-size: 12px;
                    }
                }
                .more{
                    display: none;
                }
                .line{
                    right:24%;
                }

            }
            .swiper-slide-active{
                .text{
                    .pm{
                        white-space: normal;
                        overflow: visible;
                       animation: none;
                    }
                }
            }
        }
    }
}
</style>
<style scoped>
    .banner .swiper-pagination {
        bottom: 5%;
        left:14%;
        width: 20%;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet {
        position: relative;
        width: 60px;
        height:4px;
        border-radius: 20px;
        margin: 0 5px;
        background-color: transparent;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet::before{
        position: absolute;
        left:0;
        top:0;
        width:8px;
        height:8px;
        border-radius: 50%;
        background-color: white;
        content:'';
        display: inline-block;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet i{
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height:8px;
        border-radius: 20px;
        background-color: #fff;
    }
    @media screen and (max-width:450px){
        .banner .swiper-pagination{
            width:40%;
        }
    }
</style>
